import { useEffect, useState } from "react";
import { isAuthenticated, logout, getAccount, flushPendingWrites, backupWeekly } from "./storage.js";
import Login from "./Login.jsx";
import AuthCallback from "./AuthCallback.jsx";
import App from "./App.jsx";

export default function Root() {
  const [route, setRoute] = useState(window.location.pathname);
  const [authed, setAuthed] = useState(isAuthenticated());
  const [account, setAccount] = useState(null);

  useEffect(() => {
    const handler = () => setRoute(window.location.pathname);
    window.addEventListener("popstate", handler);
    return () => window.removeEventListener("popstate", handler);
  }, []);

  useEffect(() => {
    if (authed && !account) {
      getAccount().then(a => a && setAccount(a));
    }
  }, [authed, account]);

  useEffect(() => {
    const handler = () => flushPendingWrites();
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, []);

  useEffect(() => {
    if (authed) {
      backupWeekly().then(r => {
        if (r?.ok) console.log("Weekly backup:", r.path);
      });
    }
  }, [authed]);

  const doLogout = () => {
    logout();
    setAuthed(false);
    setAccount(null);
    window.location.href = "/";
  };

  if (route === "/auth/callback") {
    return <AuthCallback onDone={() => { setAuthed(true); setRoute("/"); }} />;
  }
  if (!authed) return <Login />;
  return <App account={account} onLogout={doLogout} />;
}
